import { createApiSlice } from "@common";
import { CRUD_PRODUCT } from "@routes";

const apiConfig = [
  {
    name: "addProduct",
    method: "post",
    url: CRUD_PRODUCT,
    stateKey: "message"
  },
  {
    name: "getProduct",
    method: "get",
    url: CRUD_PRODUCT,
    stateKey: "data"
  },
  {
    name: "updateProduct",
    method: "put",
    url: CRUD_PRODUCT,
    stateKey: "message"
  },
  {
    name: "deleteProduct",
    method: "delete",
    url: CRUD_PRODUCT,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "product",
  apiConfig,
  customReducers);
const productSlice = slice;

export default productSlice.reducer;

export const {
  addProduct,
  getProduct,
  updateProduct,
  deleteProduct,
} = thunks;
export const { rowSelect } = actions;
